export const PRODUCT_VERTICAL_CLICK = 'CS/PRODUCT_VERTICAL_CLICK'; // eslint-disable-line
